document.addEventListener('DOMContentLoaded', () => {
    const btnsEdit = document.querySelectorAll('.btn-edit-type');
    const modal = document.getElementById('modalTypeUnit');

    // Semua elemen form
    const formFields = {
        id: document.getElementById('TypeId'),
        name: document.getElementById('TypeName'),
        category_id: document.getElementById('CategoryId'),
        driver_category_id: document.getElementById('DriverCategoryId'),
        transmission: document.getElementById('Transmission'),
        bbm_id: document.getElementById('BbmId'),
        passenger_capacity: document.getElementById('PassengerCapacity'),
        year: document.getElementById('Year'),
        warna: document.getElementById('Warna'),
        plat_nomor: document.getElementById('PlatNomor'),
        harga_bulanan: document.getElementById('harga_bulanan'),
        harga_lepas_kunci: document.getElementById('harga_lepas_kunci'),
        biaya_dalam_kota: document.getElementById('biaya_dalam_kota'),
        biaya_luar_kota: document.getElementById('biaya_luar_kota'),
        biaya_luar_batas: document.getElementById('biaya_luar_batas'),
        biaya_transfer: document.getElementById('biaya_transfer'),
        biaya_overtime: document.getElementById('biaya_overtime'),
        biaya_3_jam: document.getElementById('biaya_3_jam'),
        biaya_6_jam: document.getElementById('biaya_6_jam'),
        biaya_9_jam: document.getElementById('biaya_9_jam'),
        biaya_12_jam: document.getElementById('biaya_12_jam'),
        bbm_dalam_kota: document.getElementById('bbm_dalam_kota'),
        bbm_jarak_per_liter: document.getElementById('bbm_jarak_per_liter'),
    };

    const preview = document.getElementById('preview');
    btnsEdit.forEach(button => {
        button.addEventListener('click', () => {
            Object.keys(formFields).forEach(key => {
                if (formFields[key]) {
                    formFields[key].value = button.dataset[key] || '';

                    if (formFields[key].tagName === 'SELECT') {
                        formFields[key].dispatchEvent(new Event('change'));
                    }
                }
            });

            preview.innerHTML = '';
            if (button.dataset.car_images) {
                const images = button.dataset.car_images.split(',');
                document.getElementById('old_images').value = images.join(',');
                images.forEach(src => {
                    src = src.trim();
                    const img = document.createElement('img');
                    const wrapper = document.createElement('div');

                    wrapper.className = 'relative w-24 h-24';

                    img.src = assetBase + src;

                    img.onerror = function () {
                        this.onerror = null;
                        this.src = '/images/units/no-image.png';
                    };

                    img.className = 'w-24 h-24 object-cover rounded-md shadow-md';

                    const btn = document.createElement('button');
                    btn.type = 'button';
                    btn.innerHTML = '&times;';
                    btn.className = 'absolute top-0 right-0 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-700';
                    btn.addEventListener('click', () => {
                        wrapper.remove();
                        const oldInput = document.getElementById('old_images');
                        let arr = oldInput.value.split(',');
                        arr = arr.filter(v => v.trim() !== src);
                        oldInput.value = arr.join(',');
                    });
                    wrapper.appendChild(img);
                    wrapper.appendChild(btn);
                    preview.appendChild(wrapper);
                });
            }

            // Fokus ke input pertama
            if (formFields.name) formFields.name.focus();

            // Tampilkan modal
            modal.classList.remove('hidden');
        });
    });

    document.querySelectorAll('.toggle-aktif').forEach(cb => {
    cb.addEventListener('change', function () {
        const checkbox = this;
        const card = checkbox.closest('.bg-gray-800');
        const spinner = checkbox.parentElement.querySelector('.spinner');

        const id = checkbox.dataset.id;
        const active = checkbox.checked ? 1 : 0;

        // Loading visual
        spinner.style.display = "inline-block";
        checkbox.disabled = true;

        fetch(`/admin/typeUnit/updateStatus/${id}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({ is_active: active })
        })
        .then(res => res.json())
        .then(data => {
            if (data.success) {

                // UI highlight status
                if (active === 1) {
                    card.classList.remove('unit-card-disabled');
                } else {
                    card.classList.add('unit-card-disabled');
                }

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil!',
                    text: `Unit berhasil ${active ? 'diaktifkan' : 'dinonaktifkan'}`,
                    timer: 1500,
                    showConfirmButton: false
                });

            } else {
                throw new Error();
            }
        })
        .catch(err => {
            checkbox.checked = !active; // revert status
            Swal.fire({
                icon: 'error',
                title: 'Gagal!',
                text: 'Status gagal diperbarui!',
            });
        })
        .finally(() => {
            spinner.style.display = "none";
            checkbox.disabled = false;
        });
    });
    });

});

export function openModalTypeUnit(data = null) {
    const modal = document.getElementById('modalTypeUnit');
    const form = document.getElementById('formType');
    const idInput = document.getElementById('TypeId');
    const nameInput = document.getElementById('TypeName');
    const imageInput = document.getElementById('TypeImage');

    if (data) {
        idInput.value = data.id ?? '';
        nameInput.value = data.name ?? '';
        imageInput.value = '';
    } else {
        form.reset();
        idInput.value = '';
    }
    form.reset();
    idInput.value = '';
    modal.classList.remove('hidden');
}

export function closeModalTypeUnit() {
    const form = document.getElementById('formType');
    const modal = document.getElementById('modalTypeUnit');
    const idInput = document.getElementById('TypeId');
    form.reset();
    idInput.value = '';
    modal.classList.add('hidden');
}

window.addEventListener('click', (e) => {
    const modal = document.getElementById('modalTypeUnit');
    if (!modal) return;
    if (!modal.classList.contains('hidden') && e.target === modal) {
        closeModalTypeUnit();
    }
});
